import React from "react";
import { useSelector } from "react-redux";
import "../../assets/css/card-detail.css";
import PrivateGigTag from "../../assets/icons/PrivateGigTag.svg";
import dayjs from "dayjs";
import { Avatar } from "antd";
import { impersonate } from "../../utils/Utils";
import { USER_TYPE } from "../../constant";
import AdminAndAbs from "../AdminTag/AdminAndAbs";

export default function EmployerCard() {
  var localizedFormat = require("dayjs/plugin/localizedFormat");
  dayjs.extend(localizedFormat);
  const { employers } = useSelector((state) => state.employer);


  return (
    <>
      {employers[0]?.data?.map((item) => {
        return (
                    <div key={item._id} className="manageProfileCard" onClick={() => impersonate(USER_TYPE.EMPLOYER, item._id)}>
            <div className="manageProfileCard-e1">
              <div className="manageProfileCard-e2">
                <div className="manageProfileCard-e2-main">
                  <div className="manageProfileCard-e2-image">
                    {item?.Profiles?.PictureUrl ? (
                      <img
                                                src={process.env.REACT_APP_S3_URL + "/" + item?.Profiles?.PictureUrl}
                        alt=""
                                                onError={(e) => (e.target.src = `${process.env.REACT_APP_S3_URL}/content/img/no-pic.png`)}
                      />
                    ) : (
                      <span className="UserCharMob">
                        {item?.Profiles?.FirstName.slice(0, 1).toUpperCase()}
                      </span>
                    )}
                  </div>
                  <div className="manageProfileCard-e2-name">
                    {item?.Profiles?.FirstName
                                            ? `${item?.Profiles?.FirstName} ${item?.Profiles?.LastName ? item?.Profiles?.LastName : ""
                        }`
                      : item?.UserName
                      ? item?.UserName
                      : "NA"}
                  </div>
                 <AdminAndAbs isAdmin={item?.isAdmin}
                 isAbs={item?.isAbs} />
                  <div
                    className={`manageProfileCard-e3 ${
                      item?.Deactivated
                        ? "Deactivated"
                        : item.IsActive === null || item?.IsActive
                        ? "Active"
                        : "Inactive"
                    } `}
                  >
                    {item?.Deactivated
                      ? "Deactivated"
                      : item.IsActive === null || item?.IsActive
                      ? "Active"
                      : "Inactive"}
                  </div>
                </div>
                <div className="manageProfileCard-e2-field">
                                    {item?.Profiles?.CompanyName ? item?.Profiles?.CompanyName : "NA"} | {item?.Professions?.ProfessionCode}
                </div>
                <div className="manageProfileCard-e2-date">
                  Created on &nbsp;
                                    {
                                        item?.LastLoginDate !== null
                    ? dayjs(item.LastLoginDate).format("LLL").replace(",", "")
                                            : dayjs(item.Created).format("LLL").replace(",", "")
                                    }
                                    {item?.isEmployerPrivate &&
                                        <img className="ml-18" src={PrivateGigTag} alt="pvt" />}
                </div>
                <div className="Private-cantiner">
                  {item.EmployeeAssociation?.length > 0
                    ? item.EmployeeAssociation.map((data, index) => {
                        if (index > 3) return null; // Return null instead of undefined
                        return (
                                                <div className="PrivatePicName" key={data._id || index}>
                            {" "}
                            {/* Add a unique key */}
                            <span>
                              <Avatar
                                src={
                                  data?.PictureUrl
                                    ? `${process.env.REACT_APP_S3_URL}/${data?.PictureUrl}`
                                    : null
                                }
                                style={{ fontSize: "14px" }}
                                size={24}
                              >
                                {index > 2
                                  ? data?.length - 2
                                  : data?.PvtEmpName
                                  ? data?.PvtEmpName[0]
                                  : "N/A"}
                              </Avatar>
                            </span>
                            <span className="PrivatePicName-Pvt-Name">
                              {data?.PvtEmpName}
                            </span>
                          </div>
                        );
                      })
                    : "N/A"}
                </div>
              </div>
            </div>
          </div>
                )
      })}
    </>
    )
}